__turbopack_context__.v({
  "Icon": "OfficeLocation-module-scss-module__anUMOG__Icon",
  "OfficeLocation": "OfficeLocation-module-scss-module__anUMOG__OfficeLocation",
  "Pretitle": "OfficeLocation-module-scss-module__anUMOG__Pretitle",
});
